export default "/images/type-strikethrough.svg?f20e1b4d7bae7f43d4bc5c54f017f60a";